import { gql } from 'apollo-angular';

export const legalTextFields = `
  agb
  imprint
  privacy
  digitalDocumentsReceival
  digitalDocumentsReceivalMandatory
  chatbotUsage
  accessibilityDeclaration
  chatbotUsageId
  agbId
  privacyId
  digitalDocumentsReceivalId
`;

export const getLegalTextsQuery = gql`
  query getLegalTexts {
    legalTexts {
      ${legalTextFields}
    }
  }
`;
